<template>
  <div style="overflow: hidden">
    <vs-row>
      <div v-for="(item, index) in hours" :key="index">
        <vs-col
          style="margin-top: 25px"
          vs-justify="center"
          vs-align="center"
          vs-w="2"
        >
          <vs-button
            @click="removeItem(index)"
            color="danger"
            type="filled"
            size="small"
            icon-pack="feather"
            icon="icon-trash"
            class="ml-5"
          />
        </vs-col>
        <vs-col vs-justify="center" vs-align="center" vs-w="5">
          تا ساعت :
          <div class="flex justify-end align-center">
            <the-mask
              class="input"
              v-model="item.to"
              :mask="['##:##']"
              :masked="true"
              placeholder="برای مثال: 22:00"
            />
          </div>
        </vs-col>
        <vs-col vs-justify="center" vs-align="center" vs-w="5">
          از ساعت :
          <the-mask
            class="input"
            v-model="item.from"
            :mask="['##:##']"
            :masked="true"
            placeholder="برای مثال: 12:00"
          />
        </vs-col>
      </div>
      <vs-button
        v-if="hours.length < 3"
        @click="addTimespan()"
        color="primary"
        block
        icon-pack="feather"
        icon="icon-plus"
        class="ml-5"
        >اضافه کردن بازه جدید</vs-button
      >
      <vs-col>
        <div class="flex justify-end align-center">
          <vs-button
            @click="save()"
            color="primary"
            block
            icon-pack="feather"
            icon="icon-check"
            class="mr-5"
            >{{ timespan.hour.length > 0 ? "بروزرسانی" : "ذخیره" }}</vs-button
          >
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ArrayToJson } from "../../helpers/array";
import providerApiService from "../../services/api/ProviderApiService";

export default {
  name: "HourModal",
  data() {
    const timespan =
      this.timespan.hour.length > 0
        ? [...this.timespan.hour]
        : [{ from: "", to: "" }];

    return {
      hours: [...timespan],
    };
  },
  components: {},
  methods: {
    save() {
      let data = this.data.filter((item) => item.hour.length > 0);
      const newData =
        this.hours.length > 0
          ? [{ day: this.timespan.day, hour: this.hours }]
          : null;

      const currentIndex = data.findIndex(
        (item) => item.day === this.timespan.day
      );
      if (currentIndex >= 0) {
        data[currentIndex].hour = this.hours;
      } else {
        data = [...data, ...newData];
      }
      data.sort((a, b) => a.day - b.day);

      this.$vs.loading();
      providerApiService
        .submitProviderHours(
          this.currentProvider.id,
          ArrayToJson(data),
          this.hourId
        )
        .then((result) => {
          this.$vs.notify({
            text: "عملیات با موفقیت انجام شد.",
            color: "success",
            position: "bottom-center",
          });
          this.$emit("timeConfiremd", this.hours, result.resource.id);
        })
        .catch((err) => {
          this.$vs.notify({
            text: err.getErrorDescriptions(),
            color: "danger",
            position: "bottom-center",
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    addTimespan() {
      this.hours.push({ from: "", to: "" });
    },
    removeItem(index) {
      this.hours.splice(index, 1);
    },
  },
  computed: mapGetters({
    currentProvider: "profile/currentProvider",
  }),
  watch: {},
  props: {
    timespan: {
      required: false,
      type: Object,
    },
    data: {
      required: false,
      type: Array,
    },
    hourId: {
      required: false,
      type: Number,
    },
  },
};
</script>

<style scoped lang="scss">
.colon {
  font-size: 1.2rem;
  font-weight: bold;
  color: #000;
  text-align: center;
  margin: 13px 8px 0;
}

input {
  text-align: center;
  border-radius: 5px;
  border: 1px solid lightgray;
  width: 100%;
  padding: 5px;
  margin-top: 3px;
}
</style>
